import styled from 'styled-components';

export const TaxonomyForm = styled.div`
	min-width: 250px;
`;
